import { GameEvent } from '@nolimitcity/slot-game/bin/core/event/GameEvent';
import { BarbarianBetlineView } from './BarbarianBetlineView';
import { BaseController } from '@nolimitcity/slot-game/bin/core/base/BaseController';
import { EventHandler } from '@nolimitcity/slot-game/bin/core/event/EventHandler';
import { ServerEvent } from '@nolimitcity/slot-game/bin/core/server/event/ServerEvent';


export class BarbarianFuryBetlineController extends BaseController {

    private _view: BarbarianBetlineView;

    constructor() {
        super();
        this._view = new BarbarianBetlineView();
        this.addEventListener();
    }
    /**
     * function to add event listeners
     */
    private addEventListener(): void {
        EventHandler.addEventListener(this, "betLineEvent_showWinBetLine", (event: GameEvent) => this._view.showBetline(event.params[0]))
        EventHandler.addEventListener(this, "betLineEvent_hideAllBetLines", () => this._view.hideAllBetlines());
        EventHandler.addEventListener(this, "SHOW_INDIVIDUAL_BETLINE_WIN", (event: GameEvent) => this._view._showBetlineAmount = event.params[0]);
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event: GameEvent) => this._view._initData = event.params[0]);
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event: GameEvent) => this._view._parsedGameData = event.params[0]);
    }

}